import React from 'react';
import { Card, CardContent, Skeleton, Box, Grid } from '@mui/material';

const ProductSkeleton = () => (
  <Card sx={{ my: 1, border: 1, borderRadius: '5%', borderColor: 'grey.300', boxShadow: 0 }}>
    <CardContent>
      <Box>
        <Skeleton variant="text" sx={{ mx: 'auto', maxWidth: '80%' }} />
      </Box>
      <Box sx={{ width: '100%', aspectRatio: '1/1', borderRadius: '5%', overflow: 'hidden' }}>
        <Skeleton variant="rectangular" sx={{ width: '100%', height: '100%' }} />
      </Box>
      <Box>
        <Skeleton variant="text" sx={{ mx: 'auto', maxWidth: '40%', py: 1, mb: 1 }} />
        <Skeleton variant="rectangular" height={36} width={80} sx={{ mx: 'auto', borderRadius: 1 }} />
      </Box>
    </CardContent>
  </Card>
);

const ProductSkeletonGrid = () => (
  <Grid container spacing={4} px={{ xs: 1, md: 2, lg: 4 }}>
    {[1, 2, 3, 4, 5, 6].map((i) => (
      <Grid key={i} size={{ lg: 4, md: 6, xs: 12 }} px={{ xs: 1, md: 2, lg: 4 }}>
        <ProductSkeleton />
      </Grid>
    ))}
  </Grid>
);

export default ProductSkeletonGrid;
